import { useEffect, useState } from 'react';
import axios from 'axios';

export const useMenuList = () => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const [history, sethistory] = useState(0);
    const [refund, setrefund] = useState(0);
    const [complaint, setcomplaint] = useState(0);

    useEffect(() => {
        const fetchCount = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/get_sidebar_count`, {
                    params: { branch_id },
                });
                sethistory(response.data.history_count);
                setrefund(response.data.refund_count);
                setcomplaint(response.data.complaint_count);
            } catch (error) {
                console.log('Error fetching sidebar counts:', error);
            }
        };

        fetchCount();
    }, [branch_id]);

    const MenuList = [
        //Dashboard
        {
            title: 'Dashboard',
            iconStyle: "fas fa-house fs-4",
            to: 'dashboard',
            permission: 'view_dashboard',
        },

        //Branch Management
        {
            title: 'Branch Management',
            classsChange: 'mm-collapse',
            iconStyle: "fa-solid fa-code-branch fs-4",
            permission: 'branch_man',  // << main group permission
            content: [
                {
                    title: 'Manage Branch',
                    to: 'manage-branch',
                    permission: 'man_branch',
                },
                {
                    title: 'Manage Delivery Point',
                    to: 'manage-delivery-point',
                    permission: 'man_dpoint',
                }
            ],
        },

        //Lead Management
        {
            title: 'Lead Management',
            classsChange: 'mm-collapse',
            iconStyle: "fa-solid fa-people-arrows fs-4",
            permission: 'lead_man',  // << main group permission
            content: [
                {
                    title: 'Manage Lead',
                    to: 'manage-lead',
                    permission: 'man_lead',
                },
                {
                    title: 'Manage Followup',
                    to: 'manage-followup',
                    permission: 'man_followup',
                },
                {
                    title: 'Manage Calls',
                    to: 'manage-calls',
                    permission: 'man_calls',
                },
                {
                    title: 'Manage Coupon',
                    to: 'manage-coupon',
                    permission: 'man_coupon',
                },
                // {
                //     title: 'Manage Cloud Call',
                //     to: 'manage-cloud-call'
                // },
                {
                    title: 'Lead Calendar',
                    to: 'manage-calendar',
                    permission: 'lead_calender',
                },
                {
                    title: 'Lead Source',
                    to: 'manage-source',
                    permission: 'lead_source',
                }
            ],
        },

        // Team Management
        {
            title: 'Team Management',
            classsChange: 'mm-collapse',
            iconStyle: "fa-solid fa-people-group fs-4",
            permission: 'team_man',  // << main group permission
            content: [
                {
                    title: 'Team Lead',
                    to: 'team-lead',
                    permission: 'team_lead',
                },
                {
                    title: 'Team Followup',
                    to: 'team-followup',
                    permission: 'team_followup',
                },
                {
                    title: 'Team Call',
                    to: 'team-call',
                    permission: 'team_calls',
                },
                {
                    title: 'Team Promise',
                    to: 'team-promise',
                    permission: 'team_promise',
                }
            ],
        },

        // Subscriber
        {
            title: 'Subscriber Management',
            iconStyle: "fa-solid fa-user-tie fs-4",
            to: 'manage-subscribers',
            permission: 'subscri_man',  // << main group permission
        },

        // subscription Management
        {
            title: 'Subscription Management',
            classsChange: 'mm-collapse',
            iconStyle: "fa-solid fa-money-bill-trend-up fs-4",
            permission: 'subs_man',  // << main group permission
            content: [
                {
                    title: 'Manage Subscription',
                    to: 'manage-subscriptions',
                    permission: 'man_subs',
                },
                {
                    title: 'Manage Drop',
                    to: 'manage-drop',
                    permission: 'man_drop',
                },
            ]

        },

        // Payment Management
        {
            title: 'Payments Management',
            iconStyle: "fa-solid fa-money-bill-wave fs-4",
            classsChange: 'mm-collapse',
            permission: 'pay_man',  // << main group permission
            content: [
                {
                    title: 'Manage Payments',
                    to: 'payments-management',
                    permission: 'man_payment',
                },
                {
                    title: 'Manage History',
                    to: 'payments-history',
                    permission: 'man_history',
                    count: history,
                    tooltip: "Pending Approval",
                },
                {
                    title: 'Manage Refund',
                    to: 'manage-refund',
                    permission: 'man_refund',
                    count: refund,
                    tooltip: "Pending Refund Approval",
                },
            ]
        },

        //Package Management
        {
            title: 'Package Management',
            classsChange: 'mm-collapse',
            iconStyle: "fa-solid fa-shapes fs-4",
            // permission: 'pack_man',  // << main group permission
            content: [
                {
                    title: 'Manage Items',
                    to: 'manage-items',
                    // permission: 'man_items',
                },
                {
                    title: 'Manage Products',
                    to: 'manage-products',
                    // permission: 'man_product',
                },
                {
                    title: 'Manage Product Quantity',
                    to: 'manage-product-quantity',
                    // permission: 'product_quantity',
                },
                {
                    title: 'Manage Packages',
                    to: 'manage-packages',
                    // permission: 'man_pack',
                },
            ],
        },

        //Productions Management
        {
            title: 'Production Management',
            classsChange: 'mm-collapse',
            iconStyle: "fa-solid fa-chart-line fs-4",
            content: [
                {
                    title: 'Menu Maker',
                    to: 'menu-maker',
                },
                {
                    title: 'Manage Daily Orders',
                    to: 'manage-daily-orders',
                },
                {
                    title: 'Manage Packing',
                    to: 'manage-packing',
                },
                {
                    title: 'Manage Wastage',
                    to: 'manage-wastage',
                },
                     {
                title: 'Manage Delivery Sheet',
                to: 'pages-sample'
              },

                // {
                //     title: 'Manage Production Costing',
                //     to: 'manage-production-costing',
                // },
            
            ]
        },

        // Purchase
        {
            title: 'Purchase Management',
            classsChange: 'mm-collapse',
            iconStyle: "fa-solid fa-boxes-stacked fs-4",
            content: [
                {
                    title: 'Manage Vendors',
                    to: 'manage-vendors',
                },
                {
                    title: 'Manage Purchase',
                    to: 'manage-purchase',
                },
                {
                    title: 'Purchase History',
                    to: 'purchase-history',
                },
                // {
                //     title: 'Manage Stocks',
                //     to: 'manage-stocks',
                // },
                {
                    title: 'Manage Pricebook',
                    to: 'manage-pricebook',
                }
            ]
        },

        // Stock
        {
            title: 'Stock Management',
            classChange: 'mm-collapse', // fixed spelling
            iconStyle: "fa-solid fa-warehouse fs-4",
            content: [
                { title: 'Manage Raw Materials', to: 'manage-rawmaterials' },
                { title: 'Manage Stocks-In', to: 'manage-stockin' },
                { title: 'Manage Storage', to: 'manage-stocks' },
                { title: 'Manage Stocks-Out', to: 'manage-stockout' },
                { title: 'Manage Kitchen Material', to: 'manage-weeklyConsumption' },
               
                
            ]
        },

        //Delivery ManagementManage Kitchen Material
        {
            title: 'Delivery Management',
            classsChange: 'mm-collapse',
            iconStyle: "fa-solid fa-people-carry-box fs-4",
            content: [
                {
                    title: 'Manage Tripsheets',
                    to: 'manage-tripsheet',
                },
                {
                    title: 'Manage Delivery',
                    to: 'manage-delivery',
                },
                //  {
                //     title: 'Manage Tracking',
                //     to: 'manage-tracking',
                // }

            ]
        },

        //Complaints Management
        {
            title: 'Complaints Management',
            classsChange: 'mm-collapse',
            iconStyle: "fa-solid fa-triangle-exclamation fs-4",
            permission: 'comp_man',  // << main group permission
            content: [
                {
                    title: 'Manage Complaints',
                    to: 'manage-complaints',
                    count: complaint,
                    tooltip: "Open Complaints",
                }
            ]
        },
        
            {
        title: 'Catering & Corp Menu Management',
        // iconStyle: "fa-solid fa-utensils fs-4",
        iconStyle: "fa-solid fa-bell-concierge fs-4",
        to: 'catcorpmenu',
     
    },

        //Corporates Management
        {
            title: 'Corp Order Management',
            classsChange: 'mm-collapse',
            iconStyle: "fa-solid fa-hotel fs-4",
            content: [
                {
                    title: 'Manage Corporate Customer',
                    to: 'manage-corporate-customer',
                },
                {
                    title: 'Manage Corporate Order',
                    to: 'manage-corporate-order',
                },
                {
                    title: 'Manage Corporate Payment',
                    to: 'corporate-payment',
                },
                // {
                //     title: 'Manage Corporate Delivery',
                //     to: 'corporate-delivery',
                // }

            ]
        },

        //Catering Management
        {
            title: 'Catering Management',
            classsChange: 'mm-collapse',
            iconStyle: "fa-solid fa-layer-group fs-4 pe-1",
            content: [
                {
                    title: 'Manage Customer',
                    to: 'manage-catering-customer',
                },
                {
                    title: 'Manage Catering Order',
                    to: 'manage-catering-order',
                },
                {
                    title: 'Manage Catering Payment',
                    to: 'catering-payment',
                },
                // {
                //     title: 'Manage Catering Delivery',
                //     to: 'catering-delivery',
                // }

            ]
        },

        // //Maintenance Management
        // {
        //     title: 'Maintenance Management',
        //     classsChange: 'mm-collapse',
        //     iconStyle: "fa-solid fa-truck-fast fs-4",
        //     content: [
        //         {
        //             title: 'Manage Vehicles',
        //             to: 'manage-vehicles',
        //         },

        //         {
        //             title: 'Manage Maintenance',
        //             to: 'manage-maintenance',
        //         },
        //     ]
        // },
        
        //Maintenance Management
        {
            title: 'Maintenance Management',
            classsChange: 'mm-collapse',
            iconStyle: "fa-solid fa-truck-fast fs-4",
            content: [
                {
                    title: 'Manage Vehicles',
                    to: 'manage-vehicles',
                },
                {
                    title: 'Manage Machinery',
                    to: 'manage-machinery',
                },
                {
                    title: 'Manage Maintenance',
                    to: 'manage-maintenance',
                }
            ]
        },

        // KPI
        {
            title: 'KPI Management',
            classChange: 'mm-collapse',
            iconStyle: "fa-solid fa-warehouse fs-4",
            content: [
                { title: 'Manage Target', to: 'kpi-manage-target' },

            ]
        },

        // Metric Management
        {
            title: 'Metrics Management',
            classChange: 'mm-collapse',
            iconStyle: "fa-solid fa-warehouse fs-4",
            content: [
                { title: 'Forecast Metrics', to: 'manage-forecast-metrics' },

            ]
        },

        //HR Management
        {
            title: 'HR Management',
            classsChange: 'mm-collapse',
            iconStyle: "fa-solid fa-users-viewfinder fs-4",
            content: [
                {
                    title: 'Manage Staff',
                    to: 'manage-staff',
                },
                {
                    title: 'Manage Attendance',
                    to: 'manage-attendance',
                },
                {
                    title: 'Manage Payouts',
                    to: 'manage-payouts',
                },
            ]
        },

        // Monitoring
        {
            title: 'Monitoring Tools',
            classsChange: 'mm-collapse',
            iconStyle: "fa-solid fa-desktop fs-4",
            content: [
                {
                    title: 'Cronjob Monitor',
                    to: 'cronjob-monitor',
                },
                {
                    title: 'Maintenance Mode',
                    to: 'manage-maintenancemode',
                },
                {
                    title: 'User Log',
                    to: 'manage-userlogs',
                },
                {
                    title: 'Call Log',
                    to: 'call-log-monitor',
                }


            ]
        },

        //Accounts Management
        {
            title: 'Accounts Management',
            classsChange: 'mm-collapse',
            iconStyle: "fa-solid fa-money-bill-transfer fs-4",
            content: [
                {
                    title: 'Daily Accounts',
                    to: 'daily-accounts',
                },
                {
                    title: 'Profit & Loss',
                    to: 'profit-loss',
                },
                {
                    title: 'Trial Balance',
                    to: 'trial-balance',
                }

            ]
        },

        //Users Management
        {
            title: 'Users Management',
            classsChange: 'mm-collapse',
            iconStyle: "fa-solid fa-users-gear fs-4",
            content: [
                {
                    title: 'Manage Users',
                    to: 'users-manage',
                },
                {
                    title: 'Manage User Role',
                    to: 'manage-users-role',
                }

            ]
        },

        //Settings
        {
            title: 'Settings',
            iconStyle: "fas fa-gears fs-4",
            to: 'settings',
        },

    ]

    return MenuList;
};